//@components
import Context from 'context/appContext';
import { useContext } from 'react';
import { getCurrentQuestions, getPriceToShow } from 'utils/utils';
import SmallSwitch from '../small-switch'
// @styles 
import './styles.scss'
import { useEffect } from 'react';
import { useState } from 'react';

export default function SwitchCard({ addCoverage, prismicMedia, coverages }) {

    const { setPriceToShow, formStatus: { steps, currentStep, currentQuestion } } = useContext(Context);
    const [value, setValue] = useState(null)

    useEffect(() => {
        setData()
    }, [steps, currentStep, currentQuestion])
    const handleClick = (info, active) => {
        const newCoverages = coverages && coverages.filter(c => c.coverageId !== "6637");
        setPriceToShow(getPriceToShow(active ? coverages : newCoverages));
    };

    const setData = () => {
        const question = getCurrentQuestions(steps, currentStep, currentQuestion)
        setValue(question?.primary.switchcard || null)
    }

    return (
        <>
            <div className="swtichcard-title">
                Protección adicional para ti
            </div>
            <div className="swtichcard-container">
                {addCoverage && addCoverage.map((aditional, index) =>
                    aditional && (<div className="swtichcard-container-item" id={index}>
                        <img src={`${prismicMedia}/${aditional.image}`} alt={aditional?.coverageName} />
                        <div className="swtichcard-container-item-text">
                            <p className="swtichcard-container-item-title">{aditional.coverageName}</p>
                            <p className="swtichcard-container-item-description">{aditional.description}</p>
                        </div>
                        <SmallSwitch info={aditional} index={aditional.coverageKey} handleClick={handleClick} />
                    </div>)
                )}
            </div>
            <div className="swtichcard-description">
                <p dangerouslySetInnerHTML={{ __html: value }} />
            </div>
        </>
    )
}